import { useCallback } from "react";
import { useSelector } from "react-redux";

import { tenantIdSelector } from "@/react/features/customer/customerSlice";
import { useErrorNotification } from "@/react/notifications";

import { useGetQueuesByMediaTypeQuery } from "./api/queues";

export const useQueuesData = (options) => {
  const { shouldNotifyOnError = true } = options ?? {};
  const tenantName = useSelector(tenantIdSelector);

  const queuesQueryResult = useGetQueuesByMediaTypeQuery({ tenantName });
  const queues = queuesQueryResult.data;

  useErrorNotification(shouldNotifyOnError && queuesQueryResult.error);

  const getQueueById = useCallback(
    (id) => queues?.find((queue) => queue.id === id),
    [queues]
  );
  const getQueueByName = useCallback(
    (name) => queues?.find((queue) => queue.name === name),
    [queues]
  );

  return {
    ...queuesQueryResult,
    queryFunctions: {
      getQueueById,
      getQueueByName,
    },
  };
};

export default useQueuesData;
